<template>
  <div class="print-form-bus">
    <div v-for="page in pages" :key="page">
      <p class="onetitle" style="margin-bottom: 2px">送 货 单</p>
      <div class="form-info">
        <table style="width: 100%; font-size: 8px">
          <tr>
            <td style="width: 35%">
              购货单位: {{ form.fBillingName }}
            </td>
            <td style="width: 35%">
              客户名称: {{ form.fCustomer }}
            </td>
            <td style="width: 15%">
              日期:{{ form.fDate }}
            </td>
            <td style="width: 15%;text-align: right; ">
              NO:{{ form.fCkBillNo }}
            </td>
          </tr>
          <tr>
            <td style="width: 35%">
              经营许可证号/备案凭证号:{{ form.fBusinessNo }}
            </td>
            <td style="width: 35%">
              经营地址:{{ form.fAddress_jy }}
            </td>
            <td colspan="2">发货日期:{{ form.date_fh }}</td>
          </tr>
          <tr>
            <td style="width: 35%">
              送货地址:
              {{ form.fAddress_sh }}
            </td>
            <td style="width: 35%">
              联系电话:
              {{ form.fPhone }}
            </td>
            <td colspan="2">供货单位:{{ form.fSupplier }}</td>
          </tr>
        </table>
      </div>
      <table class="tableDetails" style="width: 100%; font-size: 8px">
        <tr style="font-size: 8px; font-weight: bold; text-align: center">
          <th style="width: 120px">名称</th>
          <th style="width: 120px">型号/规格</th>
          <th style="width: 50px">单位</th>
          <th style="width: 70px">数量</th>
          <th style="width: 90px">单价</th>
          <th style="width: 90px">金额</th>
          <th style="width: 145px">生产批号</th>
          <th style="width: 70px">生产日期</th>
          <th style="width: 70px">失效日期</th>
          <th style="width: 100px">序列号（追溯号）</th>
          <th style="width: 220px">储运条件</th>
          <th style="width: 110px">注册证号/备案凭证编号</th>
          <th style="width: 90px">医疗器械注册人/备案人</th>
          <th style="width: 110px">生产企业</th>
          <th style="width: 110px">生产企业许可证号/备案凭证编号</th>
        </tr>
        <tr
          v-for="(item, index) in items(page)"
          :key="index"
          style="word-break: break-all; font-size: 5px; text-align: center"
        >
          <td>{{ item.fName }}</td>
          <td>{{ item.fModel }}</td>
          <td>{{ item.fUnit }}</td>
          <td>{{ item.fQty }}</td>
          <td>{{ item.fPrice_fh }}</td>
          <td>{{ item.fTotal }}</td>
          <td>{{ item.fBatchNo }}</td>
          <td>{{ item.fDate_Sc }}</td>
          <td>{{ item.expiryDate }}</td>
          <td>{{ item.fRetroactiveNo }}</td>
          <td>{{ item.fTransportDes }}</td>
          <td>{{ item.fRegisterNumber }}</td>
          <td>{{ item.fRegistrar }}</td>
          <td>{{ item.fProduction }}</td>
          <td>{{ item.fProductionNumber }}</td>
        </tr>
        <tr v-if="page + 1 == pages.length" style="font-size: 8px">
          <td colspan="5">合 计</td>
          <td colspan="10" style="text-align: left">{{ form.fAmount }}</td>
        </tr>
      </table>
      <div style="margin-top: 10px; border: none">
        <table style="width: 100%; font-size: 8px">
          <tr style="font-size: 8px">
            <td style="width: 70%">
              送货单位及经手人(盖章):{{ form.fCheckName }}
              <img v-if="form.fSealUrl1" class="imgYZ" :src="form.fSealUrl1">
            </td>
            <td style="flex-direction: row; align-items: center; width: 30%">
              收货单位及经手人(盖章):
              <img v-if="form.fSealUrl2" class="imgYZ" :src="form.fSealUrl2">
            </td>
          </tr>
        </table>
      </div>
      <div style="text-align: center; margin-top: 5px; page-break-after: always">
        {{ page + 1 }}/{{ pages.length }}
      </div>
    </div>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'

export default {
  data: function() {
    return {
      form: {
        entrys: []
      },
      loading: false,
      pageSize: 5
    }
  },
  computed: {
    pages: function() {
      var count = Math.ceil(this.form.entrys.length / this.pageSize)
      var rtn = []
      for (let i = 0; i < count; i++) {
        rtn.push(i)
      }
      console.log('pages', rtn)
      return rtn
    }
  },
  methods: {
    refresh: async function(fid) {
      this.loading = true
      const res = await this.$httpPost(
        'BusinessManage/Delivery/DeliveryPrint2',
        {
          fid: fid
        }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
      return true
    },
    items: function(page) {
      var rtn = []
      for (let i = 0; i < this.pageSize; i++) {
        const itemIdx = page * this.pageSize + i
        if (itemIdx >= this.form.entrys.length) break
        const item = this.form.entrys[itemIdx]
        rtn.push(item)
      }
      console.log(rtn, 'rtn')
      return rtn
    },
    fmtDateTime: function(dt) {
      var m = moment(dt, 'YYYY-MM-DD HH:mm:ss')
      return m.format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.print-form-bus {
  //  margin: 0;
  //  padding: 0;
  .form-title {
    text-align: center;
    font-weight: bold;
    font-size: 29px;
    font-family: 华文行楷;
    margin-top: -5px;
    margin-bottom: 60px;
  }
  .onetitle {
    font-weight: bold;
    font-size: 25px;
    font-family: 华文行楷;
    text-align: center;
    margin: 0;
  }

  .tableDetails {
    width: 100%;
    border-collapse: collapse;
  }

  .tableDetails,
  .tableDetails td,
  .tableDetails th {
    border: 1px solid black;
  }

  .imgYZ {
    width: 100px;
    height: 100px;
    border-width: 0px;
    vertical-align: middle;
  }
  .form-info {
    font-size: 10px;
    margin-bottom: 5px;
    span {
      float: right;
      margin-left: 35px;
    }
  }
}
</style>

<style  scoped media='print'>

    @page {

        margin: 1cm 1cm 4cm 1cm ;
        size: landscape ;
      }
</style>
